export default __webpack_public_path__ + "static/media/regulatory--tractors-only--g1.ea2f343e.png";